/* user roles have to match with backend roles */
export enum commentsType {
  commentPost = 1,
  replyComment,
}
